import React from 'react'
import { styled } from '@mui/material'

const Banner = styled('div')({
    position: 'fixed',
    bottom: 100,
    left: '50%',
    transform: 'translateX(-50%)',
    width: 'calc(100% - 48px)',
    maxWidth: 360,
    backgroundColor: 'rgba(160, 20, 20, 0.92)',
    backdropFilter: 'blur(8px)',
    WebkitBackdropFilter: 'blur(8px)',
    color: 'white',
    borderRadius: 12,
    padding: '14px 16px',
    zIndex: 9999,
    fontFamily:
        '-apple-system, BlinkMacSystemFont, "Helvetica Neue", Helvetica, Arial, sans-serif',
    fontSize: 14,
    lineHeight: 1.5,
    textAlign: 'center',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.35)',
})

const ReloadButton = styled('button')({
    display: 'block',
    margin: '10px auto 0',
    padding: '7px 20px',
    border: '1.5px solid rgba(255, 255, 255, 0.6)',
    borderRadius: 8,
    background: 'transparent',
    color: 'white',
    fontSize: 13,
    fontFamily: 'inherit',
    cursor: 'pointer',
    '&:active': {
        backgroundColor: 'rgba(255, 255, 255, 0.15)',
    },
})

function ErrorToast({ message }) {
    if (!message) return null

    return (
        <Banner role="alert">
            {message}
            <ReloadButton onClick={() => window.location.reload()}>
                Reload
            </ReloadButton>
        </Banner>
    )
}

export { ErrorToast }
